import heic2any from "heic2any";

export const getImageInfo = async (url, options = {}) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    Object.keys(options).forEach(key => {
      image[key] = options[key];
    });
    image.onload = () => {
      const { width, height } = image;
      resolve({ width, height, ratio: width / height, image });
    };
    image.onerror = reject;
    image.src = url;
  });

export const isBlobUrl = url => {
  try {
    return new URL(url).protocol === "blob:";
  } catch (error) {
    return false;
  }
};

export const fileToBlob = async file => {
  const ext = (file.name || file.path || "").split(".").pop().toLowerCase();

  if (["heic", "heif"].includes(ext)) {
    const outputBlob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.7
    });
    return outputBlob;
  }

  return file;
};

export default {};
